let alarmAudio = null;
let alarmUnlocked = false;

const MARKET_INTELLIGENCE_ALARM_ENABLED_KEY =
  'spxGammaMarketIntelligenceAlarmEnabled';

function getBooleanLocalStorageValue(key) {
  return localStorage.getItem(key) === 'true';
}

function setBooleanLocalStorageValue(key, enabled) {
  localStorage.setItem(key, enabled ? 'true' : 'false');
}

export function initializeMarketIntelligenceAlarm() {
  if (!alarmAudio) {
    alarmAudio = new Audio('/sounds/trade-alert.mp3');
    alarmAudio.preload = 'auto';
    alarmAudio.volume = 0.85;
  }

  return alarmAudio;
}

async function unlockAlarmAudio() {
  const audio = initializeMarketIntelligenceAlarm();

  try {
    audio.muted = true;
    await audio.play();
    audio.pause();
    audio.currentTime = 0;
    audio.muted = false;

    alarmUnlocked = true;
    return true;
  } catch (error) {
    alarmUnlocked = false;
    console.warn('[MIS ALARM] Browser blocked audio unlock:', error);
    return false;
  }
}

async function playAlarmAudio(label = 'MIS ALARM') {
  if (!alarmUnlocked) return;

  const audio = initializeMarketIntelligenceAlarm();

  try {
    audio.currentTime = 0;
    await audio.play();
  } catch (error) {
    console.warn(`[${label}] Failed to play alarm:`, error);
  }
}

export function getMarketIntelligenceAlarmToggleState() {
  return getBooleanLocalStorageValue(MARKET_INTELLIGENCE_ALARM_ENABLED_KEY);
}

export function setMarketIntelligenceAlarmEnabled(enabled) {
  setBooleanLocalStorageValue(
    MARKET_INTELLIGENCE_ALARM_ENABLED_KEY,
    enabled
  );
}

export function isMarketIntelligenceAlarmEnabled() {
  return getMarketIntelligenceAlarmToggleState() && alarmUnlocked;
}

export async function unlockMarketIntelligenceAlarm() {
  return unlockAlarmAudio();
}

export async function enableMarketIntelligenceAlarm() {
  const unlocked = await unlockMarketIntelligenceAlarm();

  if (!unlocked) {
    setMarketIntelligenceAlarmEnabled(false);
    return false;
  }

  setMarketIntelligenceAlarmEnabled(true);
  return true;
}

export function disableMarketIntelligenceAlarm() {
  setMarketIntelligenceAlarmEnabled(false);
  alarmUnlocked = false;
}

export async function playMarketIntelligenceAlarm() {
  if (!isMarketIntelligenceAlarmEnabled()) return;
  await playAlarmAudio('MIS ALARM');
}
